function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Loader, Table as MantineTable } from '@mantine/core';
import styles from './Table.module.scss';
import Panel from './Panel';
import fastDeepEqual from 'fast-deep-equal';
import { useIntl } from 'react-intl';
export function TableHeader(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(MantineTable.Thead, _object_spread_props(_object_spread({
        className: styles.tableHeader
    }, props), {
        children: children
    }));
}
var EmptyState = /*#__PURE__*/ React.memo(function EmptyState(param) {
    var renderEmptyState = param.renderEmptyState, panelProps = param.panelProps;
    if (renderEmptyState == null) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Panel, _object_spread_props(_object_spread({
        className: styles.emptyStateContainer
    }, panelProps), {
        children: renderEmptyState()
    }));
});
var LoadingState = /*#__PURE__*/ React.memo(function LoadingState(param) {
    var panelProps = param.panelProps;
    var renderEmptyState = React.useCallback(function() {
        return /*#__PURE__*/ _jsx(Loader, {});
    }, []);
    return /*#__PURE__*/ _jsx(EmptyState, {
        panelProps: panelProps,
        renderEmptyState: renderEmptyState
    });
}, function(prev, next) {
    return fastDeepEqual(prev.panelProps, next.panelProps);
});
function Row(param) {
    var row = param.row, index = param.index, renderRow = param.renderRow;
    return renderRow(row, index);
}
var MemoizedRow = /*#__PURE__*/ React.memo(Row, function(prev, next) {
    return prev.row === next.row && prev.index === next.index;
});
function defaultKeyExtractor(row, index) {
    if (row != null && (typeof row === "undefined" ? "undefined" : _type_of(row)) === 'object') {
        if ('key' in row && typeof row.key === 'string') {
            return row.key;
        }
        if ('id' in row && typeof row.id === 'string') {
            return row.id;
        }
        if ('_id' in row && typeof row._id === 'string') {
            return row._id;
        }
    }
    return index.toString();
}
function Table(param) {
    var data = param.data, extraData = param.extraData, keyExtractor = param.keyExtractor, panelProps = param.panelProps, renderRow = param.renderRow, renderHeader = param.renderHeader, renderFooter = param.renderFooter, renderEmptyState = param.renderEmptyState;
    // we want to use useIntl here to trigger re-renders when the locale changes
    useIntl();
    var isLoading = data == null;
    var isEmpty = data != null && data.length === 0;
    if (isLoading) {
        return /*#__PURE__*/ _jsx(LoadingState, {
            panelProps: panelProps
        });
    }
    if (isEmpty) {
        return /*#__PURE__*/ _jsx(EmptyState, {
            renderEmptyState: renderEmptyState,
            panelProps: panelProps
        });
    }
    return /*#__PURE__*/ _jsxs(Panel, _object_spread_props(_object_spread({
        className: styles.panel
    }, panelProps), {
        children: [
            /*#__PURE__*/ _jsxs(MantineTable, {
                className: styles.table,
                children: [
                    /*#__PURE__*/ _jsx(TableHeader, {
                        children: renderHeader()
                    }),
                    data != null ? /*#__PURE__*/ _jsx(MantineTable.Tbody, {
                        children: data.map(function(row, index) {
                            return /*#__PURE__*/ _jsx(MemoizedRow, {
                                row: row,
                                index: index,
                                renderRow: renderRow
                            }, keyExtractor != null ? keyExtractor(row, index) : defaultKeyExtractor(row, index));
                        })
                    }) : null
                ]
            }),
            renderFooter != null ? /*#__PURE__*/ _jsx("div", {
                className: styles.footer,
                children: renderFooter()
            }) : null
        ]
    }));
}
function shallowEqual(arr1, arr2) {
    if (!Array.isArray(arr1) || !Array.isArray(arr2) || arr1.length !== arr2.length) {
        return false;
    }
    return arr1.every(function(element, index) {
        return element === arr2[index];
    });
}
// Table will only re-render when the data or extraData changes
// This is to prevent re-rendering the entire table when the parent component re-renders
export default /*#__PURE__*/ React.memo(Table, function(prev, next) {
    return (prev.data === next.data || fastDeepEqual(prev.data, next.data)) && (prev.extraData === next.extraData || shallowEqual(prev.extraData, next.extraData));
});
